import {Establishment} from "@model/establishment";
import {ImplantationDto, ImplantationDtoMapper} from "./implantationDto";

export interface EtablissementDto {
  id: string;
  fase: number;
  fasePO: number;
  nom: string;
}

export interface EtablissementAvecImplantationsDto {
  id: string;
  fase: number;
  fasePO: number;
  implantations: ImplantationDto[];
};

export const EtablissementDtoMapper = {
  toDomain: (dto: EtablissementAvecImplantationsDto): Establishment => ({
    id: dto.id,
    fase: dto.fase,
    fasePO: dto.fasePO,
    implantations: dto.implantations.map(ImplantationDtoMapper.toDomain),
  })
};